<div class="rm-header">
    <span>Add New SubDoc Signer</span>
  </div>
  <div class="row justify-content-center pt-4">
    <div class="col-12" style="font-size: medium;">
      Please add the name and email of the person who will be a signer on the Sub Doc.
    </div>
  </div>
  <div class="row justify-content-center pt-3">
    <form [formGroup]="fg">
        <div class="col-12">
            <mat-form-field class="form-field">
                <mat-label>Full Name of Signer</mat-label>
                <input type="text" formControlName="fullName" matInput
                    placeholder="Full name of Signer" required>
            </mat-form-field>
              
        </div>
        <div class="col-12">
            <mat-form-field class="form-field">
                <mat-label>Email of Signer</mat-label>
                <input matInput type="email" formControlName="email" placeholder="Email of the Sub Doc Signer">
                <mat-hint align="end">The document will be sent to this address</mat-hint>
            </mat-form-field>
        </div>
    </form>
  </div>
  <mat-dialog-actions class="space-between pt-4">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="fg.value" [disabled]="fg.invalid">Add Signer</button>
  </mat-dialog-actions>
  